<template>
  <v-sheet class="overflow-hidden header-desktop-height" @scroll="handleScroll">
    <v-app-bar
      class="
        d-flex
        align-center
        justify-center
        header-desktop-height header-desktop-app-bar
      "
      id="header-desktop-app-bar"
      color="#f7f7f7"
      elevate-on-scroll
      fixed
    >
      <v-container class="py-0">
        <v-sheet
          width="100%"
          height="100%"
          color="transparent"
          class="d-flex justify-space-between align-center"
        >
          <router-link to="/">
            <img
              v-if="informations.img"
              :src="files + informations.img"
              :alt="informations.name"
              class="d-block header-desktop-brand"
              height="58px"
            />
          </router-link>

          <div class="d-flex flex-column align-end">
            <div class="d-flex align-center">
              <template v-for="({ text, to }, keyMenu) in menuTop">
                <v-btn
                  :key="text"
                  class="
                    primary--text
                    text--lighten-2 text-caption text-lg-body-1 text-none
                    font-weight-regular
                    px-2
                    nav-link
                  "
                  :class="{ 'ml-lg-2': keyMenu > 0 }"
                  :to="to"
                  active-class="nav-link-active"
                  min-width="auto"
                  depressed
                  tile
                  text
                >
                  {{ text }}
                </v-btn>
              </template>

              <v-btn
                v-if="informations.tel"
                class="
                  primary--text
                  text--lighten-2 text-caption text-lg-body-1 text-none
                  font-weight-medium
                  pl-3
                  pr-2
                  ml-1 ml-lg-2
                  nav-link
                "
                :href="getTelLinkFromPhone(informations.tel)"
                active-class="nav-link-active"
                depressed
                tile
                text
              >
                <v-icon color="primary" :size="mdAndDown ? 16 : 18" left>
                  fa-phone-alt
                </v-icon>
                {{ informations.tel }}
              </v-btn>

              <v-btn
                v-if="informations.whatsapp"
                class="
                  primary--text
                  text--lighten-2 text-caption text-lg-body-1 text-none
                  font-weight-medium
                  pl-3
                  pr-2
                  ml-1 ml-lg-2
                  nav-link
                "
                :href="getTelLinkFromPhone(informations.whatsapp)"
                active-class="nav-link-active"
                depressed
                tile
                text
              >
                <v-icon color="primary" :size="mdAndDown ? 18 : 22" left>
                  fab fa-whatsapp
                </v-icon>
                {{ informations.whatsapp }}
              </v-btn>

              <v-btn
                v-for="{ title, link, icon } in social"
                :key="link"
                color="transparent"
                :href="link"
                target="_blank"
                :title="title"
                depressed
                x-small
                fab
              >
                <v-icon color="primary" :size="mdAndDown ? 20 : 25">
                  {{ icon }}
                </v-icon>
              </v-btn>
            </div>

            <v-sheet
              class="header-separator"
              color="rgba(33, 25, 21, 0.20)"
              width="calc(100% - 8px)"
              height="1px"
            ></v-sheet>

            <div class="d-flex align-center">
              <template v-for="({ text, to }, keyMenu) in menu">
                <v-btn
                  :key="text"
                  class="
                    primary--text
                    text-caption text-lg-body-1 text-none text-uppercase
                    font-weight-medium
                    px-2
                    nav-link
                  "
                  :class="{ 'ml-1 ml-lg-2': keyMenu > 0 }"
                  :to="to"
                  active-class="nav-link-active"
                  tile
                  depressed
                  text
                >
                  <div class="nav-link-item">
                    {{ text }}
                  </div>
                </v-btn>
              </template>

              <template
                v-if="
                  customerArea.tenant_portal || customerArea.landlord_portal
                "
              >
                <v-btn
                  v-if="
                    customerArea.tenant_portal === customerArea.landlord_portal
                  "
                  class="
                    white--text
                    text-caption text-lg-body-1 text-none text-uppercase
                    font-weight-medium
                    px-2
                    ml-1 ml-lg-2
                    nav-link
                  "
                  active-class="nav-link-active"
                  color="primary"
                  :href="customerArea.tenant_portal"
                  target="_blank"
                  depressed
                  tile
                >
                  Área do Cliente
                </v-btn>

                <v-menu v-else offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="
                        white--text
                        text-caption text-lg-body-1 text-none text-uppercase
                        font-weight-medium
                        px-2
                        ml-1 ml-lg-2
                        nav-link
                      "
                      color="primary"
                      active-class="nav-link-active"
                      depressed
                      tile
                    >
                      Área do Cliente
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item
                      v-if="customerArea.tenant_portal"
                      :href="customerArea.tenant_portal"
                      target="_blank"
                    >
                      <v-list-item-title
                        class="text-caption font-weight-medium"
                      >
                        Sou Locatário
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="customerArea.landlord_portal"
                      :href="customerArea.landlord_portal"
                      target="_blank"
                    >
                      <v-list-item-title
                        class="text-caption font-weight-medium"
                      >
                        Sou Proprietário
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </div>
          </div>
        </v-sheet>
      </v-container>
    </v-app-bar>
  </v-sheet>
</template>

<script>
import { menuTop, menu } from "../../../config";
import { getSocial } from "../../../utils/getSocial";
import { getTelLinkFromPhone } from "../../../utils/getTelLinkFromPhone";
import { getWhatsappLinkFromPhone } from "../../../utils/getWhatsappLinkFromPhone";

export default {
  data: () => ({
    menuTop,
    menu,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    customerArea() {
      return this.$rest("customer-area").item;
    },
    social() {
      return getSocial(this.informations);
    },
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
  },
  methods: {
    getTelLinkFromPhone,
    getWhatsappLinkFromPhone,
    handleScroll() {
      if (document.documentElement.scrollTop > 50)
        document
          .getElementsByTagName("body")[0]
          .classList.add("v-app-bar--is-active");
      else
        document
          .getElementsByTagName("body")[0]
          .classList.remove("v-app-bar--is-active");
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.header-desktop-height::v-deep {
  height: 142px !important;
  transition: all 0.1s linear;

  .v-toolbar__content {
    height: 142px !important;
    padding: 0;
    width: 100%;
  }

  .nav-link {
    &-item {
      border-bottom: 2px solid transparent;
    }

    &-active {
      .nav-link-item {
        border-bottom: 2px solid var(--v-primary-base);
      }
    }

    &:before {
      opacity: 0 !important;
    }
  }
}

.header-desktop-app-bar {
  .header-desktop-brand {
    height: 58px;
    transition: all 0.1s linear;

    @media screen and (max-width: 1279.9px) {
      height: 42px;
    }
  }

  .header-separator {
    margin: 12px 0;
    transition: all 0.1s linear;

    @media screen and (max-width: 1279.9px) {
      margin: 8px 0;
    }
  }
}

.v-app-bar--is-active {
  .header-desktop-app-bar {
    height: 98px !important;
    transition: all 0.1s linear;

    .v-toolbar__content {
      height: 98px !important;
    }
  }

  .header-separator {
    margin: 4px 0;
  }
}
</style>
